import "./_style.less";
import Paragraph from "antd/lib/typography/Paragraph";
import { useTranslation } from "react-i18next";
import { FC } from "react";
import { RadioProps } from "antd";
import moment from "moment";
import { Psychologist } from "../../../../models/Psychologist";
import { VuiNumberFormat } from "../../../../@vendor/components";
import clsx from "clsx";

interface IPsychologistCard {
  data: Psychologist;
  nearestSchedule?: string;
  onSelect?: (v: Psychologist | null) => void;
  isSelected?: boolean;
}

const PsychologistCard: FC<IPsychologistCard & RadioProps> = (props) => {
  const { data, nearestSchedule, onSelect, isSelected = false } = props;
  const { t } = useTranslation();

  return (
    <div
      className={clsx("psychologist-card-new", {
        selected: isSelected,
      })}
      onClick={() => {
        if (onSelect) {
          onSelect(isSelected ? null : data);
        }
      }}
    >
      <div className={"psychologist-card-content-wrapper"}>
        <img
          className="psychologist-card-image first-image"
          src={data?.photo?.url}
          alt={data?.title}
        />
        <div>
          <Paragraph className="psychologist-card-name">{data?.name}</Paragraph>
          <div
            className="psychologist-card-title"
            dangerouslySetInnerHTML={{ __html: data?.title || "" }}
          ></div>

          {nearestSchedule ? (
            <Paragraph className="psychologist-card-nearest-schedule">
              {t("common.text.nearestAvailableSchedule")},{" "}
              <b>{moment(nearestSchedule).format("dddd, DD MMMM YYYY")}</b>
            </Paragraph>
          ) : (
            <div style={{ marginTop: 6, marginBottom: 13 }} />
          )}

          <Paragraph className="psychologist-card-rate">
            <VuiNumberFormat
              prefix="IDR "
              suffix=" / hour"
              value={data?.sixty_minutes_price}
            />
          </Paragraph>
        </div>
      </div>
    </div>
  );
};

export default PsychologistCard;
